<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Centros de Costos</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cat-centro-costos-nuevo', params: {} }"
              >
                <i class="fa fa-plus"></i>
                Nueva Centro Costo
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <form
                @submit="filterData"
                action="#"
                class="form-inline justify-content-sm-end"
              >
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActiva"
                  @click="filterData"
                >
                  <option value="null">Todos</option>
                  <option value="1">Activa</option>
                  <option value="0">Inactiva</option>
                </select>
              </form>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="input-group-append">
              <button
                class="btn btn-link btn-sm"
                type="button"
                v-on:click="clearFilterData"
              >
                <i class="fa fa-times"></i>
              </button>
              <select
                class="form-control form-control-sm rounded bright"
                v-model="filtertraslado"
                @click="filterData"
              >
                <option value="null">Todos</option>
                <option value="1">Permite Traslado</option>
                <option value="0">No permite Traslado</option>
              </select>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Nombre del Centro Costo</th>
                <th scope="col" class="text-center">Permite Traslado</th>
                <th scope="col" class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td scope="row">{{ current.id }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div
                    v-if="current.permite_traslados"
                    class="status-pill green"
                    data-title="Activa"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.permite_traslados"
                    class="status-pill red"
                    data-title="Permite Traslados"
                    data-toggle="tooltip"
                  ></div>
                </td>

                <td class="text-center">
                  <div
                    v-if="current.activa"
                    class="status-pill green"
                    data-title="No Permite traslados"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.activa"
                    class="status-pill red"
                    data-title="Inactiva"
                    data-toggle="tooltip"
                  ></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import CentroCostoService from "@/services/catalogos/CentroCostoService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActiva: 1,
      filtertraslado: 1,
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activa: this.filterActiva,
        permite_traslados: this.filtertraslado,
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActiva,
        permite_traslados: this.filtertraslado,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.filtertraslado = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activa: this.filterActiva,
        permite_traslados: this.filtertraslado,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      CentroCostoService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-centro-costos-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-centro-costos-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
